var templates = {
  'modal': require('./modal/base/modal.hbs'),
  'modal_alert': require('./modal/base/alert.hbs'),
  'modal_wrapper': require('./modal/base/wrapper.hbs'),
  'modal_buttons': require('./modal/base/buttons.hbs'),
  'modal_loader': require('./modal/base/loader.hbs'),
  'modal_restricted_template_load': require('./modal/base/restricted-template-load.hbs'),
  'modal_restricted_template_confirm': require('./modal/base/restricted-template-confirm.hbs'),
  'modal_layout_load': require('./modal/base/layout-load.hbs'),
  'alert_default': require('./modal/alert/default.hbs'),
  'alert_delete_confirm': require('./modal/alert/delete-confirm.hbs'),
  'alert_span': require('./modal/alert/span.hbs'),
  'alert_bold': require('./modal/alert/bold.hbs'),
  'popupmenu_showmore': require('./popupmenu/show-more.hbs'),
  'popupmenu_additional': require('./popupmenu/additional.hbs'),
  'popupmenu_font_size_list': require('./popupmenu/font-size-list.hbs'),
  'popupmenu_heading_list': require('./popupmenu/heading-list.hbs'),
  'popupmenu_bleed_size_list': require('./popupmenu/bleed-size-list.hbs'),
  'popupmenu_stroke_dasharray': require('./popupmenu/stroke-dasharray.hbs')
};

module.exports = function (key, args) {
  if (templates[key]) return templates[key](args);
};
